import React, { Component, PropTypes } from 'react';
import localize from '../../../../localize';
import settings from '../../../../../config/settings';
import CSSModules from 'react-css-modules';
import Icon from '../../../shared/Icon';

class ObjectDetailDefinition extends Component {
    static propTypes = {
        object: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isDefinitionListVisible: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.object !== nextProps.object) {
            this.setState({isDefinitionListVisible: false});
        }
    }

    l =(key) => {
        const str = `${this.props.lang}.components.ObjectDetail.${key}`;
        return localize(str);
    };

    showAttribute = (attr) => (
        settings.availableObjectCategories.indexOf(attr) > -1
    );

    toggle = () => {
        this.setState({
            isDefinitionListVisible: !this.state.isDefinitionListVisible,
        });
    };

    renderIcon = () => {
        const ico = !this.state.isDefinitionListVisible ? 'Vitra_Down.svg' : 'Vitra_Up.svg';
        return <Icon icon={ ico } />;
    };

    renderItem = (attr, dd) => (
        !!this.props.object[attr] &&
        this.showAttribute(attr) &&
        [
            <dt key={0}>{ this.l(attr) }</dt>,
            <dd key={1}>{ dd || this.props.object[attr] }</dd>
        ]
    );

    getObjeTitle = () => {
        const { ObjObjectTitleTxt, ObjObjectTitleSubTxt } = this.props.object;
        let title = ObjObjectTitleTxt;
        title += !!ObjObjectTitleSubTxt ? `/${ObjObjectTitleSubTxt}` : '';
        return title;
    };



    render() {
        return (
            <aside>
                <h2 styleName="toggle" onClick={ this.toggle }>
                    <span className="content-box">
                        { this.l('objectAttributes') }
                        { this.renderIcon() }
                    </span>
                </h2>
                <div
                    styleName="section-content"
                    className={ !this.state.isDefinitionListVisible ? 'is-hidden' : '' }
                >
                    {
                        this.state.isDefinitionListVisible &&
                        <dl className="content-box">
                            { this.renderItem('ObjObjectNumberTxt') }
                            { this.renderItem('ObjObjectTitleTxt', this.getObjeTitle()) }
                            { this.renderItem('ObjDesigner') }
                            { this.renderItem('ObjCategoryVoc') }
                            { this.renderItem('ObjDateGrp_DateFromTxt') }
                            { this.renderItem('ObjDateGrp_Notes2Clb') }
                            { this.renderItem('ObjDateGrp_Notes3Clb') }
                            { this.renderItem('ObjDateTxt') }
                            { this.renderItem('ObjMaterialTechniqueTxt') }
                            { this.renderItem('ObjDimension') }
                            { this.renderItem('ObjObjectNumberGrp_Part1Txt', ``) }
                        </dl>
                    }
                </div>
            </aside>
        );
    }
}

export default CSSModules(ObjectDetailDefinition);


// WEBPACK FOOTER //
// ./app/components/Object/Detail/Definition/ObjectDetailDefinition.jsx